export default __webpack_public_path__ + "static/media/yoni-asia.5bc3a55f.png";